/**
 * RegExp
 */
export const mailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const atLeastOneDigitRegExp = /^(?=.*\d)/;
export const atLeastOneLowerCaseLetterRegExp = /[a-z]+/;
export const atLeastOneUpperCaseLetterRegExp = /[A-Z]+/;
export const atLeastOneSpecialCharacterRegExp = /[!$%&=?^*;,.#/+-]+/;
export const passwordRegExp = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!$%&=?^*;,.#/+-])[a-zA-Z0-9!$%&=?^*;,.#/+-]{8,}$/;
export const onlyNumberRegExp = /^[0-9]*$/;
